import { Center, AspectRatio, Text, Flex, Icon, Container } from '@chakra-ui/react';
import NextImage from 'next/image';
import { FC } from 'react';

import IcCamera from '@/assets/icons/ic-camera.svg';
import IcDollar from '@/assets/icons/ic-dollar.svg';
import IcHome from '@/assets/icons/ic-home.svg';
import IcPeople from '@/assets/icons/ic-people.svg';
import PresentationHeadingImage from '@/assets/images/publishers/bg-scientific-impact.png';

import { SimpleIconCard } from '@/components/ui/features/publishers/GlobalHeadwindsSection/components/SimpleIconCard';

export const GlobalHeadwindsSection: FC = () => {
  return (
    <Center bgColor="black" position="relative">
      <AspectRatio
        position="absolute"
        objectFit="cover"
        minH={{ base: '820px', md: '670px', lg: '623px' }}
        w="full"
        ratio={1905 / 530}
      >
        <NextImage
          objectPosition="center"
          quality={90}
          layout="fill"
          priority={true}
          src={PresentationHeadingImage}
          alt="Hero cover"
        />
      </AspectRatio>
      <Container px={{ base: 5, lg: 10 }}>
        <Flex
          top={0}
          minH={{ base: '820px', md: '670px', lg: '623px' }}
          textAlign="center"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          position="relative"
          w="full"
        >
          <Text fontFamily="heading" fontWeight="bold" maxW="790px" fontSize={{ base: '2xl', md: '4xl', lg: '5xl' }}>
            Don&apos;t Let Global Headwinds
            <br />
            <Text
              as="span"
              fontFamily="heading"
              backgroundClip="text"
              bgGradient="linear-gradient(90deg, #E179F1 0%, #BD8AF5 26.56%, #70B5EF 50%, #5BC5DF 74.48%, #52A3B0 98.96%)"
            >
              Diminish Your Scientific Impact
            </Text>
          </Text>
          <Text fontSize={{ base: 'lg', lg: 'xl' }} mt={{ base: 4, md: 6, lg: 8 }} maxW="1000px">
            In today&apos;s landscape, visa concerns and travel restrictions prevent key researchers from attending.
            Every empty seat represents a lost connection, a weakened program, and a blow to your conference&apos;s
            prestige and budget.
          </Text>
          <Flex
            alignContent="center"
            justifyContent="center"
            flexWrap={{ base: 'wrap', lg: 'nowrap' }}
            mt={{ base: 6, md: 8, lg: 10 }}
            gap={4}
          >
            <SimpleIconCard
              label="Presenters Unable to Travel"
              description="Key speakers missing due to visa issues"
              icon={<Icon w="20px" h="18px" color="violet.500" as={IcHome} />}
            />
            <SimpleIconCard
              label="Attendee Anxiety"
              description="Participants nervous about visa status"
              icon={<Icon w="24px" h="24px" color="violet.500" as={IcPeople} />}
            />
            <SimpleIconCard
              label="Program Gaps"
              description="Weakened scientific programming"
              icon={<Icon w="22px" h="22px" color="violet.500" as={IcCamera} />}
            />
            <SimpleIconCard
              label="Revenue Loss"
              description="Decreased attendance and prestige"
              icon={<Icon w="17px" h="17px" color="violet.500" as={IcDollar} />}
            />
          </Flex>
        </Flex>
      </Container>
    </Center>
  );
};
